import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { fadeInAnimation } from '../_animations/fade-in.animation';
import { SessionService } from '../session/session.service';
import { PortalMode } from '../enum/portalmode.enum';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent {
  public isLoggedIn: boolean;
  private loggedInSubscription: Subscription;

  public get isBorgenarMode(): boolean {
    return this.sessionService.getPortalMode() === PortalMode.Borgenar;
  }

  constructor(
    protected authService: AuthService,
    protected sessionService: SessionService) {
    this.loggedInSubscription = this.authService.getIsLoggedInMessage().subscribe(
      (isLoggedIn: number) => {
        this.isLoggedIn = (isLoggedIn === 1);
      });
  }

  public ngOnDestroy() {
    if (this.loggedInSubscription) {
      this.loggedInSubscription.unsubscribe();
    }
  }
}
